import { createSlice } from '@reduxjs/toolkit';

export const initialState = [];

const legacyConfigurationsSlice = createSlice({
	name: 'legacyConfigurations',
	initialState,
	reducers: {
		setLegacyConfigurations(state, action) {
			return action.payload;
		}
	}
});

export const { setLegacyConfigurations } = legacyConfigurationsSlice.actions;

export default legacyConfigurationsSlice.reducer;
